import React, { Dispatch, RefObject, useCallback, useContext, useEffect, useRef } from "react";
import { DispSize, WindowContext } from "./WindowContextProvider";

export interface HeaderProps {
    setHH: Dispatch<number>,
    setScale: Dispatch<number>
}

export const Header = ({setHH,setScale}: HeaderProps) : React.JSX.Element => {
    const ds: DispSize = useContext(WindowContext);
    const hgref: RefObject<HTMLCanvasElement | null> = useRef(null);
    const divref: RefObject<HTMLDivElement | null> = useRef(null);

    var scale: number = ds.height>ds.width ? 1 : 1+0.4*Math.log(ds.width/ds.height);
    console.log('scale='+scale);
    var hh: number = 0.1*scale*ds.height;
    const off1 = 0.3;
    var astep: number = ((1.2+off1)*(0.1*ds.width)-1.2*(0.1*ds.width))/1;
    var animStep: number = 0;
    var timer: NodeJS.Timeout;

    const paintLogo = () => {
        const ctx = hgref.current?.getContext('2d');
        if(ctx !== null && ctx !== undefined) {
            ctx.clearRect(0, 0, ds.width, hh);
            ctx.imageSmoothingEnabled = true; 
            var fs1i = 0.5;
            ctx.font = `bold ${fs1i*hh}px KoHo`;
            var eimt1 = ctx.measureText('NOVA');
            var fsw1 = Math.abs(eimt1.actualBoundingBoxLeft) + Math.abs(eimt1.actualBoundingBoxRight);
            var fsh1 = Math.abs(eimt1.actualBoundingBoxAscent) + Math.abs(eimt1.actualBoundingBoxDescent);
            var eimt2 = ctx.measureText('INTELIGENCIJA');
            var fsw2 = Math.abs(eimt2.actualBoundingBoxLeft) + Math.abs(eimt2.actualBoundingBoxRight);
            var fsh2 = Math.abs(eimt2.actualBoundingBoxAscent) + Math.abs(eimt2.actualBoundingBoxDescent);
            while(fsw1 > 0.2*ds.width || fsw2 > 0.5*ds.width) {
                fs1i -= 0.05;
                if(fs1i <= 0) break;
                else ctx.font = `bold ${fs1i*hh}px KoHo`;
                eimt1 = ctx.measureText('NOVA');
                fsw1 = Math.abs(eimt1.actualBoundingBoxLeft) + Math.abs(eimt1.actualBoundingBoxRight);
                fsh1 = Math.abs(eimt1.actualBoundingBoxAscent) + Math.abs(eimt1.actualBoundingBoxDescent);
                eimt2 = ctx.measureText('INTELIGENCIJA');
                fsw2 = Math.abs(eimt2.actualBoundingBoxLeft) + Math.abs(eimt2.actualBoundingBoxRight);
                fsh2 = Math.abs(eimt2.actualBoundingBoxAscent) + Math.abs(eimt2.actualBoundingBoxDescent);
            }
            astep = 0.1 * (1.2*fsw1);

            /*const imageData = ctx.getImageData(0, 0, ds.width, hh);
            const data = imageData.data; 

            for (let i = 0; i < data.length; i += 4) {
                const alpha = Math.random() * 40 +150; 
                data[i] = 255;  
                data[i + 1] = 255; 
                data[i + 2] = 255; 
                data[i + 3] = alpha; 
            }
            ctx.putImageData(imageData, 0, 0);*/

            var fs = `rgba(74, 95, 211, 0.6)`;
            ctx.fillStyle = fs;
            ctx.beginPath();
            ctx.moveTo(0,0);
            ctx.lineTo((1.2+off1)*fsw1,0);
            ctx.quadraticCurveTo(1.2*fsw1,0,1.2*fsw1,0.5*hh);
            ctx.quadraticCurveTo(1.2*fsw1,hh,(1.2-off1)*fsw1,hh);
            ctx.lineTo(0,hh);
            ctx.lineTo(0,0);
            ctx.fill();

            var fs = `white`;
            ctx.fillStyle = fs;
            ctx.beginPath();
            ctx.moveTo((1.2+off1)*fsw1,0);
            ctx.quadraticCurveTo(1.2*fsw1,0,1.2*fsw1,0.5*hh);
            ctx.quadraticCurveTo(1.2*fsw1,hh,(1.2-off1)*fsw1,hh);
            ctx.lineTo((1.2-off1)*fsw1+animStep,hh);
            ctx.quadraticCurveTo(1.2*fsw1+animStep,hh,1.2*fsw1+animStep,0.5*hh);
            ctx.quadraticCurveTo(1.2*fsw1+animStep,0,(1.2+off1)*fsw1+animStep,0);
            ctx.lineTo((1.2+off1)*fsw1,0);
            ctx.fill();

            var fs = `rgba(180, 20, 41, 0.6)`;
            ctx.fillStyle = fs;
            ctx.beginPath();
            ctx.moveTo((1.2+off1)*fsw1+animStep,0);
            ctx.lineTo(ds.width,0);
            ctx.lineTo(ds.width,hh);
            ctx.lineTo((1.2-off1)*fsw1+animStep,hh);
            ctx.quadraticCurveTo(1.2*fsw1+animStep,hh,1.2*fsw1+animStep,0.5*hh);
            ctx.quadraticCurveTo(1.2*fsw1+animStep,0,(1.2+off1)*fsw1+animStep,0);
            ctx.fill();

            ctx.fillStyle = 'rgb(255, 255, 255)';
            ctx.font = `bold ${fs1i*hh}px KoHo`;
            ctx.fillText('NOVA',0.1*fsw1,hh-2*((hh-fsh1)/3));
            ctx.fillStyle = 'rgb(255, 255, 255)';
            ctx.font = `bold ${fs1i*hh}px KoHo`;
            ctx.fillText('INTELIGENCIJA',1.3*fsw1+animStep,hh-1*((hh-fsh1)/3));
        }
    };

    const timerHandler = () => {
        paintLogo();
        if(animStep <= astep) {
            animStep += 1;
            timer = setTimeout(timerHandler, 40);
        }
    };

    useEffect(() => {
        scale = ds.height>ds.width ? 1 : 1+0.4*Math.log(ds.width/ds.height);
        console.log('scale='+scale);
        if(hgref.current) {
            hgref.current.width = ds.width;
            hgref.current.height = 0.1*scale*ds.height;
        }
        if(divref.current) {
            divref.current.style.height = `${0.1*scale*ds.height}px`;
        }
        hh = 0.1*scale*ds.height;
        setScale(scale);
        setHH(hh);
        astep = ((1.2+off1)*(0.1*ds.width)-1.2*(0.1*ds.width))/1;
        animStep = 0;
        timer = setTimeout(timerHandler, 40);
        return () => {
            clearTimeout(timer);
        };
    }, [ds,hh]);

    return (
        <div style={{width:'100%', position:"absolute", display:"flex", 
            fontFamily: 'KoHo', fontStyle: "normal", fontWeight: "bold"}} ref={divref}>
            <canvas style={{flex:1, width: '100%'}} ref={hgref} />
        </div>
    )
}